import { isNil } from 'lodash-es'
import styled from '@emotion/styled'
import { VerticalLayout, HorizontalLayout, justifyContents, alignItems } from 'view/styles/constants'

export const DialogRow = styled.div<{ gap?: number | string; horizontalLayout?: HorizontalLayout; verticalLayout?: VerticalLayout }>`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: ${props => (props.horizontalLayout ? justifyContents[props.horizontalLayout] : 'auto')};
  align-items: ${props => (props.verticalLayout ? alignItems[props.verticalLayout] : 'auto')};
  gap: ${props => (props.gap ? props.gap : 0)};
`

export const DialogGrid = styled.div<{ numberOfColumns: number; rowGap?: number; columnGap?: number }>`
  display: grid;
  grid-template-columns: ${props => `repeat(${props.numberOfColumns}, 1fr)`};
  justify-content: auto;
  align-items: auto;
  row-gap: ${props => (props.rowGap ? props.rowGap : '20px')};
  column-gap: ${props => (props.rowGap ? props.rowGap : '10px')};
  width: 100%;
`

export const DialogField = styled.div<{ flex?: number }>`
  flex: ${props => (!isNil(props.flex) ? `${props.flex} 0 0` : '1 0 0')};
  margin-right: 10px;
  &:last-child {
    margin-right: 0;
  }
`
